import type { FaireProductEntity } from "../../entity_types/product";

export const plant_dyed_3: FaireProductEntity = {
  token: "plant-dyed-3",
  type: "product",
  name: "Painter's Hand-Dyed Napkins",
  brandName: "Merle Works",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/04445448e31def35dd58c8d70aa23796afd548f8f5492cf110f218e7a546386a.png",
  priceDollars: 2.5,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/04445448e31def35dd58c8d70aa23796afd548f8f5492cf110f218e7a546386a.png",
  weight: 0.2,
  dimensions: {
    width: 12,
    height: 12,
    depth: 0.5,
  },
  description: "Hand-dyed napkins with unique painterly patterns",
  categoryTokens: ["cat_accessories"],
  tags: [
    "plant-dyed",
    "natural-dye",
    "sustainable-textiles",
    "handmade",
    "napkin",
    "premium",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
